import { takeLatest, call, put } from 'redux-saga/effects';
import * as alertActions from 'redux/ducks/common/alertDucks';
import * as landingActions from 'redux/ducks/landing/landingDucks';

export function* callMTService({ payload }) {
  try {
    const response = yield call('mt/service/api', payload);
    yield put(landingActions.callMTServiceSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* callDVService({ payload }) {
  try {
    const response = yield call('dv/service/api', payload);
    yield put(landingActions.callDVServiceSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export default function* landingSaga() {
  yield takeLatest(landingActions.callMTService, callMTService);
  yield takeLatest(landingActions.callDVService, callDVService);
}
